import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useExtraStocks from './useExtraStocks';

const useSingleExtrastock = () => {
  const { id: routeId } = useParams();
  const { singleItem, loading, extrastockType } = useExtraStocks(false, false);

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
    extrastockType,
  };
};

export default useSingleExtrastock;
